import { SpecialOfferProps } from '../types';
import React from 'react';
import { SpinXTemplate } from 'templates/Shared/SpinxX/SpinXTemplate';

export const SpinXSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  backgroundImage,
  backgroundColor,
  selectOffer,
  isFree,
  collectText,
  badges = [],
  inMobileMock,
  emblemBadges,
  buttonSuffixImage,
  buttonSuffixAnimation,
  salePercentage,
  salePercentageDisplayType,
}) => {
  return (
    <SpinXTemplate
      prices={prices}
      productList={productsList}
      backgroundSrc={backgroundImage}
      backgroundColor={backgroundColor}
      selectOffer={selectOffer}
      dataTestId={dataTestId}
      isFree={isFree}
      collectText={collectText}
      badges={badges}
      inMobileMock={inMobileMock}
      isSpecialOffer
      emblemBadges={emblemBadges}
      buttonSuffixImage={buttonSuffixImage}
      buttonSuffixAnimation={buttonSuffixAnimation}
      salePercentage={salePercentage}
      salePercentageDisplayType={salePercentageDisplayType}
    />
  );
};
